<template>
  <div class="card border-left-danger shadow mb-3">
    <h4 class="card-header text-danger">Registros com ações vencidas</h4>
    <div class="table-responsive table-sm px-2">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-center">Nº do Registro</th>
            <th class="text-center">Data de Abertura</th>
            <th>Responsável</th>
            <th>Tipo</th>
            <th>Descrição</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="registry in registries" :key="registry.id">
            <td class="text-center">{{ registry.numero }}</td>
            <td class="text-center">
              {{ dateSqlToDateBR(registry.dataAbertura) }}
            </td>
            <td>{{ registry.responsavel }}</td>
            <td>{{ registry.tipo }}</td>
            <td>{{ registry.descricao.substring(0, 100) }}</td>
            <td class="text-center">
              <router-link
                :to="`/details/${registry.id}`"
                class="btn btn-outline-primary"
                title="Detalhes"
              >
                <i class="fas fa-file-alt"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { dateSqlToDateBR } from '@/utils/date'

export default {
  name: 'Notification',

  props: {
    registries: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dateSqlToDateBR,
    }
  },
}
</script>
